
import 'swiper/css/swiper.css'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { LoginVO } from '@/views/biz/login/vo/login.vo'
import axios from 'axios'
import CommonUtils from '@/common-utils';

@Component
export default class FindPasswordConfirm extends Vue {
  
  @Prop() propId;
  member: LoginVO = {} as LoginVO;

  nextStep() {
    if(!this.member.memId) {
      // 아이디를 입력해 주세요.
      alert(this.$t('login.a0006'));
      return false;
    }

    // 아이디 검증 > 사용자 아이디 조회 > 존재할 경우 세션 저장 후 다음 스텝 이동
    axios.post('login/validation/member-id', this.member)
    .then(()=> {
      //this.$router.push({name: 'FindPassword'}); //단계삭제
      this.verificatonStep();
    })
  }

  // 본인인증 페이지
  verificatonStep() {
    // PC면
    if(this.$isMobile == false) {
      window.open(`${CommonUtils.createStaticUrl(this, 'RealNameForm' )}?nextRouteName=FindPasswordRetype`, "_blank", "width=762, height=800")
      return;
    } 

    this.$router.push({name: 'RealNameForm', params: {nextRouteName: 'FindPasswordRetype'}})
  }
  
  created(): void {
    this.propId && (this.member.memId = this.propId)
  }  
}
